<template>
  <div>DetailMoves</div>
</template>

<script>
export default {
  name: 'DetailMoves',
  props: {
    pokemon: {
      type: Object,
      default: () => null
    }
  }
}
</script>

<style>

</style>
